import { Injectable } from '@angular/core';
import {JSONSchema7} from 'json-schema';

export type FlattenSchemaEntry = {key: string, schema: JSONSchema7};

@Injectable({
	providedIn: 'root'
})
export class JsonSchemaFlattenerService {
	static flatProperties(schema: JSONSchema7): FlattenSchemaEntry[] {
		const crawler = new SchemaCrawler(schema);
		return crawler.getNonObjectTypedProperties();
	}
}

class SchemaCrawler {
	private readonly schema: JSONSchema7;

	constructor(schema: JSONSchema7) {
		this.schema = schema;
	}

	private readInSubSchema(schema: JSONSchema7, path: string[]): FlattenSchemaEntry[] {
		const list = [] as FlattenSchemaEntry[];
		if (!schema) {
			return list;
		}

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		for (const [key] of Object.entries(schema.properties)) {
			const propSchema = schema.properties[key] as JSONSchema7;
			const newPath = [...path];
			newPath.push(key);

			switch (propSchema.type) {
				case 'string':
					list.push({
						key: newPath.join('.'), schema: propSchema
					});
					break;
				case 'array':
					list.push({
						key: newPath.join('.'), schema: propSchema
					});
					break;
				case 'object':
					list.push(...this.readInSubSchema(propSchema, newPath));
					break;
				default:
					console.warn(`Type ${propSchema.type} not supported`);
			}
		}

		return list;
	}

	getNonObjectTypedProperties(): FlattenSchemaEntry[] {
		return this.readInSubSchema(this.schema, []);
	}

}
